// extracted by mini-css-extract-plugin
export var marginNegative = "_7o-5 _7o-3 _7o-1";
export var marginPositive = "_7o-4 _7o-3 _7o-1";
export var modalContent = "_7o-6";
export var samplesTable = "_7o-8";
export var samplesTableContainer = "_7o-7";
export var statBox = "_7o-a";
export var tableCell = "_7o-1";
export var tableCellCenter = "_7o-2 _7o-1";
export var tableCellRight = "_7o-3 _7o-1";
export var tableHeader = "_7o-0";
export var trackingNumber = "_7o-9";